import React, { useState } from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import { IoIosArrowForward } from "react-icons/io"

import { motion } from "framer-motion"

const Accordion = () => {
  const { allStrapiArticle } = useStaticQuery(graphql`
    {
      allStrapiArticle(filter: { isFeatureInterest: { eq: true } }, limit: 6) {
        nodes {
          slug
          title
        }
      }
    }
  `)

  const data = allStrapiArticle.nodes
  const [selected, setSelected] = useState(null)
  const toggleAccordion = i => {
    if (selected === i) {
      return setSelected(null)
    }
    setSelected(i)
  }

  const gridAnimate = {
    offScreen: { opacity: 0, x: 50 },
    onScreen: {
      opacity: 1,
      x: 0,
      transition: { type: "spring", bounce: 0.4, duration: 2 },
    },
  }

  const opacity = {
    offScreen: { opacity: 0 },
    onScreen: {
      opacity: 1,
      transition: { type: "spring", bounce: 0.4, duration: 2 },
    },
  }

  return (
    <section className="accordion-wrapper">
      <motion.div
        className="accordion"
        variants={gridAnimate}
        initial={"offScreen"}
        whileInView={"onScreen"}
        transition={{ staggerChildren: 0.2 }}
      >
        <h4 className="recommend-title">También te puede interesar</h4>
        {data.map((item, i) => (
          <motion.div
            key={i}
            className="item"
            variants={opacity}
            initial={"offScreen"}
            whileInView={"onScreen"}
            transition={{ staggerChildren: 0.4 }}
          >
            <div
              aria-hidden="true"
              className="title"
              onClick={() => toggleAccordion(i)}
            >
              <span>
                <IoIosArrowForward className="icon" />
              </span>
              <Link to={`/blog/${item.slug}`}>
                <h2>{item.title}</h2>
              </Link>
            </div>
            <p className={selected === i ? "content show" : "content"}>
              {selected === i && item.answer}
            </p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  )
}

export default Accordion
